

let refsAPI = process.env.VUE_APP_API_REFDATA

import Vue from 'vue'
import UTILS from '@/store/utils'
import API from '@/store/apiUtils'
import REFDATA from '@/helpers/referenceDataHelper'
import {
  RESOLUTION_TYPE
} from '@/constants'
import applicationModel from '@/store/applicationModel'
import router from '@/router'


const isResolvedWithDifferentValue = resolution => {
  // Returns true if resolution resulted in the OES value being replaced.
  // Resolving with the ERN value, or a TEXTAREA MERGE, or any kind of
  // LIST-type resolution all result in the OES value being replaced.
  return (
    resolution.type === RESOLUTION_TYPE.LIST ||
    resolution.type === RESOLUTION_TYPE.MERGE
  )
}

const getPDFURLBase = applicationType => {
  switch (applicationType) {
    default:
      return `${process.env.VUE_APP_API_EA}/v1/ea/applications/submitted`
  }
}



export default {
  setStore(store) {
    // Sets store instance for any helpers that need it
    API.setStore(store)
  },

  set({ commit }, [key, value]) {
    // Sets a value into state
    commit('set', [key, value])
  },

  renderModel({ commit, state }) {
    // Increments the counter to re-render the model (as the model is not reactive)
    commit('set', ['renderModel', state.renderModel + 1])
  },

  setFieldValue({ commit }, [field, value]) {
    // Sets a field value for a specified field (object)
    commit('set', [`application.${field.apiKey}`, value])
  },

  setReferenceData(store, [category, data]) {
    // Adds or updates a category of reference data in the store
    let referenceData = store.state.referenceData || {}
    referenceData[category] = data
    store.commit('set', ['referenceData', referenceData])
  },

  setFocus({ state, commit, dispatch }, modelRow) {
    /*
      Sets focus to the field referenced by modelRow. If that section is collapsed,
      expand it.

      Setting state.focusFieldId will trigger the UI to focus the specified field.
      However focusFieldId might already be set to this field (from a previous
      setFocus), in which case Vue would not detect the change if we set the value
      again. Instead we must clear focusFieldId before setting it. The timeout
      prevents Vue combining these two commits and not updating.
    */

    // If focusing a field inside a collapsed section, expand it...
    if (state.sectionExpandedId !== modelRow.section.id) {
      dispatch('toggleSection', modelRow.section)
    }

    commit('set', ['focusFieldId', null])
    setTimeout(function() {
      commit('set', ['focusFieldId', modelRow.id])
    }, 0)
  },

  showSpinner({ commit }) {
    commit('set', ['showSpinner', true])
  },

  hideSpinner({ commit }) {
    commit('set', ['showSpinner', false])
  },

  showMessageBox({ commit }, options) {
    commit('set', ['messageBox', options])
  },

  hideMessageBox({ commit }) {
    commit('set', ['messageBox', null])
  },

  showSnackbar({ commit }, options) {
    commit('set', ['snackbar', options])
  },

  hideSnackbar({ commit }) {
    commit('set', ['snackbar', null])
  },

  setCleanApplication({ commit, state }) {
    // Should be set before application data is modified. When applcation data
    // is saved, this clean version is included in the payload so that the API
    // can detect and save only the changed data. This was implemented as part
    // of the performance upgrades, although it is only a band-aid solution.
    commit('set', ['cleanApplication', UTILS.clone(state.application)])
  },


  setCurrentUser({ commit, state }) {
      //commit('set', ['userName', state.userName])
      //set the user's role and ID
      //commit('set', ['userID', state.userID])

      
    
  },

  // AJAX actions -----------------------------------------------------------------------



  getApplication(store, [id]) {
    return store.dispatch('getEaApplication', [id])
  },

  getReferenceData(store) {
    return new Promise(done => {
      if (store.state.referenceData) {
        done(store.state.referenceData)
      } else {
        API.get(
          `${process.env.VUE_APP_API_REFDATA}/pi-reference-data.json`,
          true
        ).then(response => {
          done(REFDATA.mapReferenceData(response.data))
        })
      }
    })
  },

  getEAProperties() {
    return new Promise(done => {
      API.get(refsAPI + `/ea-properties.json`, true).then(eaProperties => {
        done(eaProperties)
      })
    })
  },






  // APPLICATION ACTIONS -----------------------------------------------------------------------

  refreshModel(store) {
    let { state } = store

    applicationModel.create(state.application, state.ernRecord, store)
  },

  toggleSection({ commit, state }, section) {
    commit('set', [
      'sectionExpandedId',
      section.id !== state.sectionExpandedId ? section.id : null
    ])
  },


  displayApplication(store, application) {
    // Takes the supplied application data and:
    // 1. Auto-links records
    // 2. Sets application data into state
    // 3. Builds alerts and renders the UI
    var eaRecord = application.eaApplication
    store.commit('set', ['application', eaRecord])
    store.dispatch('refreshModel')
  },


  async refreshTokens() {
    const refreshToken = sessionStorage.getItem('refreshToken')
    if (refreshToken) {
      const {
        id_token,
        refresh_token,
        access_token
      } = await this._vm.$auth.DET.refreshTokens(refreshToken)
      if (id_token) {
        sessionStorage.setItem('idToken', id_token)
      }
      if (access_token) {
        sessionStorage.setItem('accessToken', access_token)
      }
      if (refresh_token) {
        sessionStorage.setItem('refreshToken', refreshToken)
      }
      return !!id_token
    } else {
      throw 'No refresh token was found'
    }
  },

  logout() {
    router.push('logout')
  },

  reauthenticateUser() {
    //this._vm.$auth.startAuth()
  },

  beginFinalInactivityTimer({ commit }) {
    this._vm.$activityMonitor.deactivate()
    commit('set', ['showTimeoutBanner', true])
  },
  showDocument({ dispatch }, filePath) {
    dispatch('getSignedDocUrl', filePath)
      .then(response => {
        window.open(response.data.body.Url, '_blank')
      })
      .catch(() => {
        dispatch('showMessageBox', {
          icon: 'exclamation',
          html: `<h2>This file could not be opened</h2>Please try again later`
        })
      })
  },
  getSignedDocUrl({ state }, fileKey) {
    let filePayload = API.getSignedURLPayload(fileKey)
    return API.post(
      `${process.env.VUE_APP_API_EA}/application/self/downloads/generateSignedUrl/`,
      filePayload,
      false
    )
  },

  getApplicationPDF(_, { applicationId, applicationType }) {
    const urlBase = getPDFURLBase(applicationType)
    return API.get(
      `${urlBase}/${applicationId}/download`,
      false,
      null,
      null,
      true
    ).then(response => response.data)
  },

  getApplicationPDFs(_, { applicationIds, applicationType }) {
    const urlBase = getPDFURLBase(applicationType)
    const idsKeyName =
     'applicationIds'
    return API.post(
      `${urlBase}/download`,
      { [idsKeyName]: applicationIds },
      true,
     null
    ).then(response => response.data.body.Location)
  },

  getAppsDocStatus(_, { applicationsInfo }) {
    return API.post(
      `${process.env.VUE_APP_API_EA}/v1/ea/applications/submitted/documentScanStatus`,
      { applications: applicationsInfo },
      true
    ).then(response => response.data.body)
  },

  getSupportingDocumentsPDFs(_, { downloadApplications }) {
    return API.post(
      `${process.env.VUE_APP_API_EA}/v1/ooa/applications/submitted/download`,
      { applications: downloadApplications },
      true,
      null
    ).then(response => response.data)
  }
}
